import { useRoute, useRouter } from "vue-router";
import { ref, computed, onMounted, watch } from "vue";

export function useRouterUtilities(refVar, queryKey) {
  const route = useRoute();
  const hasQueryParam = ref(false);
  const openDrawer = ref(false);
  const entityId = ref("");
  const router = useRouter();

  const hash = computed(() => route.hash?.split("?")[0] || null);

  const hashQueryParams = computed(() => {
    const queryString = route.hash?.split("?")[1];

    if (!queryString) return null;

    return Object.fromEntries(new URLSearchParams(queryString));
  });

  const queryParams = computed(() =>
    Object.keys(route.query).length ? route.query : null,
  );

  const removeQueryParams = () => {
    router.replace({ name: route.name, hash: route.hash, query: {} });
  };

  const removeQueryParam = (key) => {
    const query = { ...route.query };

    delete query[key];

    router.replace({ name: route.name, hash: route.hash, query });
  };

  const updateFromQuery = () => {
    const value = route.query[queryKey];

    openDrawer.value =
      route.query?.openDrawer === true || route.query?.openDrawer === "true";

    entityId.value = route.query?.entityId || "";

    if (typeof value === "string") {
      refVar.value = value;

      hasQueryParam.value = true;
    } else {
      hasQueryParam.value = false;

      refVar.value = "";
    }
  };

  if (refVar && queryKey) {
    onMounted(updateFromQuery);

    watch(() => [route.query[queryKey], route.query.openDrawer], updateFromQuery);
  }

  return {
    hasQueryParam,
    entityId,
    hash,
    hashQueryParams,
    queryParams,
    removeQueryParam,
    removeQueryParams,
    openDrawer,
  };
}
